import { useContext } from 'react';

import AuthContext from '../AuthContext';

export const useIsImpersonated = () =>
  useContext(AuthContext)?.userState?.impersonated;
